import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { HowItWorksExchangeRow } from "@/app/types/home/HowItWorksMockData";
import { UStyles } from "@/app/utils/UStyles";
import { formatMockDate } from "./HowItWorks.logic";
import styles from "./HowItWorksMock.module.css";

type Props = {
  row: HowItWorksExchangeRow;
  isLive?: boolean;
};

export default function HowItWorksMockExchange(props: Props) {
  const { row, isLive = false } = props;
  const T = useT();

  return (
    <div className={UStyles.classNames(styles.row, isLive ? styles.rowLive : "")}>
      <span className={styles.sourceTile}>
        <row.Icon />
      </span>
      <span className={styles.rowTexts}>
        <span className={styles.rowName}>{row.company}</span>
        <span className={styles.meta}>{`${T(row.titleKey)} · ${formatMockDate(row.date, T)}`}</span>
      </span>
      {isLive ? (
        <span className={styles.processing}>
          <span className={styles.processingDot} />
          {T(TKey.HOME_MEIDLY_HOW_ANALYSING)}
        </span>
      ) : (
        <span className={styles.chip}>{T(row.typeKey)}</span>
      )}
    </div>
  );
}
